import { gql } from "@apollo/client"

export const SELLABLE_ITEM_LIST_FRAG = gql`
  fragment SellableItemListFrag on SellableItemType {
    id
    name
    shortDescription
    primaryPhoto {
      id
      url
    }
    itemGroups {
      id
      name
    }
    sellableVarieties {
      id
      name
      variety {
        id
        name
        commodity {
          id
          name
        }
      }
    }
    allowedDepartments {
      id
      name
    }
  }
`

export const SELLABLE_ITEM_DETAILS_FRAG = gql`
  fragment SellableItemDetailsFrag on SellableItemType {
    id
    name
    codename
    currentStockPercentage
    shortDescription
    longDescription
    transportationType
    externalReferences {
      id
      objectId
      referenceId
      externalApp {
        id
        codename
        name
      }
    }
    secondarySkuType {
      id
      capacity
      name
    }
    itemGroups {
      id
      name
    }
    metadata {
      eanCode
      fssaiLicense
      hsnCode
      isVariant
    }
    photos {
      id
      mediaType
      url
    }
    primaryPhoto {
      id
      mediaType
      url
    }
    sellableVarieties {
      id
      name
      variety {
        id
        name
        commodity {
          id
          name
        }
      }
      grade {
        id
        name
      }
      uomCount
      uomType {
        id
        name
        codename
      }
      skuCount
      skuType {
        id
        name
      }
    }
    allowedDepartments {
      id
      name
    }
  }
`

export const RELATED_STOCK_FRAG = gql`
  fragment RelatedStockFrag on SellableItemStockType {
    id
    groupVisibility {
      id
      name
    }
    distributionCentre {
      id
      name
    }
    offerStockCount
  }
`
export const SELLABLE_ITEM_STOCK_DETAIL_FRAG = gql`
  fragment SellableItemStockDetailFrag on SellableItemStockType {
    id
    expiryDate
    variantStocks {
      id
      currentStockCount
      sellableItem {
        id
        name
        secondarySkuType {
          id
          capacity
        }
      }
      batchStocks {
        id
        name: codename
        totalQuantity
        currentStockCount
        expiryOn
        manufacturedOn
        manufacturedBy {
          id
        }
        suppliedBy {
          id
        }
      }
      unitRate
      discountedRate
      offerStockCount
      orderingConditions
      groupVisibility {
        id
        name
        category {
          id
          codename
          name
        }
      }
    }
    sellableItem {
      id
      name
      secondarySkuType {
        id
        capacity
      }
      currentStockPercentage
      childSellableItems {
        id
        name
        secondarySkuType {
          id
          capacity
        }
      }
    }
    unitRate
    isLive
    orderingConditions
    groupVisibility {
      id
      name
      category {
        id
        codename
        name
      }
    }
    minRate
    maxRate
    currentStockCount
    holdStockCount
    offerStockCount
    currentStockPercentage
    currentStockType
    discountedRate

    relatedStock {
      ...RelatedStockFrag
    }
    distributionCentre {
      id
      name
      currentStockPercentage
    }
  }
  ${RELATED_STOCK_FRAG}
`
